import React from "react";
import type { ExtraNodeData, InterfaceToRecord } from "./action-config-node";
import ActionConfigNode from "./action-config-node";
import type { NodeProps, Node } from "@xyflow/react";

type EqualNode = Node<InterfaceToRecord<ExtraNodeData>>;

export default function Equal(props: NodeProps<EqualNode>): JSX.Element {
    return <ActionConfigNode nodeKind={props.type} {...props.data} />;
}
